import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import Loader from "../../components/Loader";
import NoData from "../../components/NoData";
import Pagination from "../../components/Pagination";
import { BASE_URL, HEADERS } from "../../utils/constant";

const UserLogsList = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [date, setDate] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchLogs(currentPage);
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [search, date, currentPage, itemsPerPage]);

  const fetchLogs = async (page = 1) => {
    setLoading(true);

    try {
      const params = {
        page: page,
        page_size: itemsPerPage,
      };

      if (search) {
        params.search = search;
      }

      if (date) {
        params.date = date;
      }

      const response = await axios.get(`${BASE_URL}/users/user-logs/`, {
        headers: HEADERS,
        params,
      });

      setLogs(response.data.results || []);
      setTotalPages(response.data.total_pages || 1);
      setCurrentPage(page);
    } catch (error) {
      console.error("Error fetching logs:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="container-fluid">
      <div className="mt-3 mb-3">
        <h4>User Logs</h4>
      </div>
      <Row className="mb-3">
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Search Here..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </Col>

        <Col md={3}>
          <Form.Control
            type="date"
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
              setCurrentPage(1);
            }}
          />
        </Col>
      </Row>

      <div className="table-responsive">
        {loading ? (
          <Loader />
        ) : logs.length > 0 ? (
          <table className="table align-middle">
            <thead>
              <tr>
                <th>ID</th>
                <th>Date & Time</th>
                <th>User</th>
                <th>Email</th>
                <th>Role</th>
                <th>Module</th>
                <th>Action</th>
                <th>Description</th>
              </tr>
            </thead>

            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>
                    <span className="badge bg-primary">{log.id}</span>
                  </td>

                  <td>
                    {log.created_at
                      ? new Date(log.created_at).toLocaleString()
                      : "—"}
                  </td>

                  <td>{log.user?.full_name || "—"}</td>
                  <td>{log.user?.email || "—"}</td>
                  <td>{log?.role || "—"}</td>

                  <td>
                    <span className="badge bg-secondary">
                      {log.module || "—"}
                    </span>
                  </td>

                  <td>
                    <span className="badge bg-info">{log.action}</span>
                  </td>

                  <td>{log.description || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoData message="No Logs Found" height="400px" />
        )}
      </div>

      {logs.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}
    </div>
  );
};

export default UserLogsList;
